function IconMailPink() {
    return (
        <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="21.5" y="19.5" width="21" height="19" rx="2.5" transform="rotate(-180 21.5 19.5)" stroke="#D74DED" />
            <path d="M15.8 6H6.2C5.54 6 5.006 6.45 5.006 7L5 13C5 13.55 5.54 14 6.2 14H15.8C16.46 14 17 13.55 17 13V7C17 6.45 16.46 6 15.8 6ZM15.8 13H6.2V8L11 10.5L15.8 8V13ZM11 9.5L6.2 7H15.8L11 9.5Z" fill="#D74DED" />
        </svg>

    )
}
export default IconMailPink;